import * as React from 'react';

import './planner.scss';



export interface IProps{
    TaskDetails;
    text;
}
//references;
export interface IContextualMenuState {
  isOpen:boolean;
}




export default class TaskAttachmentList extends React.Component<IProps,IContextualMenuState>{
  
  //private _menuButtonElement: HTMLElement | null;
  constructor(props: IProps) {
    super(props); 
    this.state = {
        isOpen: false
    };     
  }
  private closeopen=(e)=>{
    this.setState({isOpen:!this.state.isOpen});
  }
  
  public render() {    
    const { isOpen} = this.state;
    let refferences=null;
    if(isOpen){
        refferences=[<div style={{marginTop:'10px'}}></div>];
        Object.keys(this.props.TaskDetails.references).map((key)=> {
            refferences.push(<div>
                <i className={["ms-Icon ms-Icon--Link",'detailbodyicon'].join(' ')}></i>
                <a href={decodeURIComponent(key)} target="_blank"> {this.props.TaskDetails.references[key].alias}</a>               
                <div style={{clear:'both',marginBottom:'10px'}}></div>
            </div>);
        });
    }
    return (
           <div style={{cursor:'pointer'}} onClick={this.closeopen}>
           <div>
               <i className={["ms-Icon ms-Icon--Attach",'detailbodyicon'].join(' ')}>  </i> {this.props.text}
               <i className={["ms-Icon ms-Icon--ChevronRightSmall",'expandicon'].join(' ')}></i>
               <div style={{clear:'both'}}></div>
           </div>
           {refferences}
            
           </div>
     );
  }
  

     

}
